import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material'
import * as React from 'react'
import { useCancelIssues } from '../../../APIs/Hooks/LimsHooks'
import { LoadingButton } from '@mui/lab'

function ConfirmCancelDialog({
  open,
  setOpen,
}: {
  open: string | undefined
  setOpen: any
}) {
  const { mutate: cancelIssue, isLoading } = useCancelIssues(setOpen)
  return (
    <Dialog
      aria-label={'Confirm Cancel Dialog'}
      open={open === 'cancel'}
      onClose={() => setOpen(undefined)}
    >
      <DialogTitle>{'Are you sure you wish to cancel this order?'}</DialogTitle>
      <DialogActions>
        <Button
          onClick={() => setOpen(undefined)}
          color="error"
        >
          No, Close
        </Button>
        <LoadingButton
          onClick={() => cancelIssue()}
          color="warning"
          loading={isLoading}
        >
          Yes, Continue
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmCancelDialog
